<section class="product-description-section" [formGroup]="descriptionForm">
  <div class="description-header">
    <span class="container-title">{{ 'text_productDescription' | dbText }}</span>
<!--    <ds-dropdown [formControl]="descriptionForm.get('status') | toFormControl"-->
<!--                 class="product-status"-->
<!--                 [value]="descriptionForm.get('status').valueChanges|async"-->
<!--                 [dsDropdownOptions]="statusOptions"-->
<!--                 [dsDropdownWidth]="'120px'">-->
<!--    </ds-dropdown>-->
  </div>
  <div class="description-form-container mt20">
    <div class="title-field-container">
      <div class="field-label">
        <span>
          {{ 'text_title' | dbText}}
        </span>
      </div>
      <input class="ds-input"
             type="text"
             placeholder=" {{ 'text_productTitlePlaceholder' | dbText}}"
             formControlName="name">
      <div class="product-description-section-invalid-note"
           *ngIf="descriptionForm?.get('name')?.touched && descriptionForm?.get('name')?.invalid">
        This field is required
      </div>
    </div>
    <div class="short-desc-field-container">
      <div class="field-label-container">
        <div class="field-label">
          <span>{{ 'text_shortDescription' | dbText }}</span>
          <i class="db-icon db-icon-ds-info-bg"
             [dsTooltip]="'text_addProductShortDesc'|dbText"
             dsTooltipPosition="right"
             dsTooltipColor="black"
             dsTooltipAlign="top"></i>
        </div>
        <div class="generate-link">
          <img src="assets/images/icons/ai-generate-grey.svg">
          <span
            (click)="openFirstTooltip=true">{{ 'text_generateWithAi' | dbText }}</span>
          <db-generate-with-ai class="ds-tooltip ds-tooltip-black ds-tooltip-medium"
                               *ngIf="openFirstTooltip"
                               [generated]="shortGenerated"
                               (showRegenerate)="shortGenerated = true"
                               [control]="descriptionForm.get('short_description')"
                               [titleControl]="descriptionForm.get('name')"
                               [descriptionType]="'short'"
                               (close)="openFirstTooltip = false"></db-generate-with-ai>
        </div>
      </div>
      <db-quill-editor placeholder="{{ 'text_productShortDescription' | dbText }}"
                       formControlName="short_description"></db-quill-editor>
    </div>
    <div class="long-desc-field-container">
      <div class="field-label-container">
        <div class="field-label">
          <span>{{ 'text_longDescription' | dbText }}</span>
          <i class="db-icon db-icon-ds-info-bg"
             [dsTooltip]="'text_addProductLongDesc'|dbText"
             dsTooltipPosition="right"
             dsTooltipColor="black"
             dsTooltipAlign="top"></i>
        </div>
        <div class="generate-link">
          <img src="assets/images/icons/ai-generate-grey.svg">
          <span (click)="openSecondTooltip=true">{{ 'text_generateWithAi' | dbText }}</span>
          <db-generate-with-ai class="ds-tooltip ds-tooltip-black ds-tooltip-medium"
                               *ngIf="openSecondTooltip"
                               [control]="descriptionForm.get('long_description')"
                               [generated]="longGenerated"
                               (showRegenerate)="longGenerated = true"
                               [titleControl]="descriptionForm.get('name')"
                               [descriptionType]="'long'"
                               (close)="openSecondTooltip = false"></db-generate-with-ai>
        </div>
      </div>
      <db-quill-editor placeholder="{{ 'text_productLongDescription' | dbText }}"
                       formControlName="long_description"></db-quill-editor>
    </div>
  </div>
</section>
